module.exports = __webpack_public_path__ + "static/media/muscle.68eb7320.jpg";